import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { BsMoon, BsSun } from 'react-icons/bs';
import { FiMenu, FiX } from 'react-icons/fi';
import { useTheme } from '../../hooks/useTheme';
import styles from './Navbar.module.css';

const navLinks = [
  { name: 'Home', to: 'home' },
  { name: 'About', to: 'about' },
  { name: 'Skills', to: 'skills' },
  { name: 'Experience', to: 'experience' },
  { name: 'Projects', to: 'projects' },
  { name: 'Certifications', to: 'certifications' },
  { name: 'Honors & Awards', to: 'honors' },
  { name: 'Contact', to: 'contact' }
];

const Navbar = () => {
  const { theme, toggleTheme } = useTheme();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);
  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <nav className={`${styles.navbar} ${scrolled ? styles.scrolled : ''}`}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <Link to="home" smooth={true} duration={500} onClick={closeMobileMenu}>
            Usman Mahmood
          </Link>
        </div>

        {/* Desktop Nav */}
        <div className={styles.desktopNav}>
          <ul className={styles.navLinks}>
            {navLinks.map((link) => (
              <li key={link.name}>
                <Link
                  to={link.to}
                  smooth={true}
                  duration={500}
                  spy={true}
                  activeClass={styles.active}
                  onClick={() => {
                    if (link.to === 'projects') {
                      window.dispatchEvent(new Event('resetProjectsCarousel'));
                    }
                  }}
                >
                  {link.name}
                  <span className={styles.indicator}></span>
                </Link>
              </li>
            ))}
          </ul>
          <button className={styles.themeToggle} onClick={toggleTheme} aria-label="Toggle Theme">
            {theme === 'dark' ? <BsMoon size={18} /> : <BsSun size={18} />}
          </button>
        </div>

        {/* Mobile Toggle */}
        <div className={styles.mobileToggle}>
          <button className={styles.themeToggle} onClick={toggleTheme} aria-label="Toggle Theme">
            {theme === 'dark' ? <BsMoon size={18} /> : <BsSun size={18} />}
          </button>
          <button className={styles.hamburger} onClick={toggleMobileMenu} aria-label="Menu">
            {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      <div className={`${styles.mobileDrawer} ${mobileMenuOpen ? styles.open : ''}`}>
        <div className={styles.drawerOverlay} onClick={closeMobileMenu}></div>
        <div className={styles.drawerContent}>
          <button className={styles.closeDrawer} onClick={closeMobileMenu}>
            <FiX size={24} />
          </button>
          <ul className={styles.mobileNavLinks}>
            {navLinks.map((link) => (
              <li key={link.name}>
                <Link
                  to={link.to}
                  smooth={true}
                  duration={500}
                  spy={true}
                  onClick={() => {
                    closeMobileMenu();
                    if (link.to === 'projects') {
                      window.dispatchEvent(new Event('resetProjectsCarousel'));
                    }
                  }}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
